import {Component, Input} from '@angular/core';
import {PreviousUrlService} from '../../_services/previous-url.service';

@Component({
	selector: 'app-toolbar-bottom',
	templateUrl: './toolbar-bottom.component.html',
	styleUrls: ['./toolbar-bottom.component.scss']
})

export class ToolbarBottomComponent {

	@Input() sidenav: any;

	constructor(public previousPageService: PreviousUrlService) {
	}
}
